export enum AccessTokenWarningActionType {
  Show = 'accessTokenWarning/SHOW',
  Hide = 'accessTokenWarning/HIDE',
}
